import React, { useState, useEffect } from 'react';

const TaskTapPitch = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [earnings, setEarnings] = useState(0);

  const slides = [
    // Slide 1: Title
    {
      id: 'title',
      content: (
        <div className="flex flex-col items-center justify-center h-full text-center">
          <h1 className="text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500 mb-8 animate-fade-in">
            TaskTap
          </h1>
          <p className="text-3xl md:text-4xl text-gray-300 animate-slide-up">
            DoorDash for Slack Micro-Tasks
          </p>
          <div className="mt-12 text-xl text-gray-500 animate-pulse">
            Press → to begin
          </div>
        </div>
      ),
      duration: 5000
    },
    // Slide 2: The Problem
    {
      id: 'problem',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-5xl font-bold text-red-400 mb-8 animate-fade-in">
            The Problem
          </h2>
          <div className="space-y-6 text-2xl text-gray-300 max-w-3xl animate-slide-up">
            <p className="flex items-center">
              <span className="text-red-500 mr-4">❌</span>
              Companies have small tasks that need doing
            </p>
            <p className="flex items-center">
              <span className="text-red-500 mr-4">❌</span>
              Workers want quick money-making opportunities
            </p>
            <p className="flex items-center">
              <span className="text-red-500 mr-4">❌</span>
              Current platforms require new apps & complex onboarding
            </p>
            <p className="flex items-center">
              <span className="text-red-500 mr-4">❌</span>
              Double-claiming causes chaos and disputes
            </p>
          </div>
        </div>
      ),
      duration: 6000
    },
    // Slide 3: The Solution
    {
      id: 'solution',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-5xl font-bold text-green-400 mb-8 animate-fade-in">
            The Solution: TaskTap
          </h2>
          <div className="bg-gray-900 border-2 border-green-400 rounded-xl p-8 max-w-4xl animate-scale-in">
            <div className="space-y-4 text-xl">
              <div className="flex items-start">
                <span className="text-green-400 mr-4 text-2xl">1.</span>
                <div>
                  <p className="font-bold text-white">Task drops in Slack</p>
                  <p className="text-gray-400">Manager posts task with reward amount</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-green-400 mr-4 text-2xl">2.</span>
                <div>
                  <p className="font-bold text-white">First click wins</p>
                  <p className="text-gray-400">Message vanishes instantly - no duplicates!</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-green-400 mr-4 text-2xl">3.</span>
                <div>
                  <p className="font-bold text-white">DM with details</p>
                  <p className="text-gray-400">Worker gets private message with instructions</p>
                </div>
              </div>
              <div className="flex items-start">
                <span className="text-green-400 mr-4 text-2xl">4.</span>
                <div>
                  <p className="font-bold text-white">Complete & get paid</p>
                  <p className="text-gray-400">Money hits account immediately</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      duration: 8000
    },
    // Slide 4: Live Demo
    {
      id: 'demo',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-4xl font-bold text-white mb-8 animate-fade-in">
            See It In Action
          </h2>
          <div className="bg-gray-900 rounded-lg p-6 max-w-2xl border border-gray-700 animate-scale-in">
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-green-400 rounded flex items-center justify-center text-black font-bold">
                T
              </div>
              <div className="flex-1">
                <div className="flex items-baseline space-x-2 mb-2">
                  <span className="font-bold text-white">TaskTap</span>
                  <span className="text-xs text-gray-500">BOT</span>
                  <span className="text-xs text-gray-500">2:34 PM</span>
                </div>
                <div className="bg-gray-800 rounded p-4 border border-gray-700">
                  <div className="mb-3">
                    <span className="text-yellow-400 font-bold">📋 New Task Available!</span>
                  </div>
                  <p className="text-white mb-2">Review 50 customer feedback entries</p>
                  <p className="text-green-400 font-bold mb-4">💰 Reward: $25</p>
                  <button
                    onClick={() => {
                      const btn = document.getElementById('claim-btn');
                      if (btn) {
                        btn.style.transform = 'scale(0)';
                        btn.style.opacity = '0';
                        setTimeout(() => {
                          if (btn.parentElement) {
                            btn.parentElement.innerHTML = '<div class="text-gray-500 italic">Message deleted</div>';
                          }
                        }, 300);
                      }
                    }}
                    id="claim-btn"
                    className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded transition-all duration-300 transform hover:scale-105"
                  >
                    ⚡ Claim Task
                  </button>
                </div>
              </div>
            </div>
          </div>
          <p className="text-xl text-gray-400 mt-6 animate-pulse">
            Click the button to see the magic!
          </p>
        </div>
      ),
      duration: 7000
    },
    // Slide 5: Earnings Counter
    {
      id: 'earnings',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-4xl font-bold text-white mb-8 animate-fade-in">
            Real Money, Real Time
          </h2>
          <div className="text-8xl md:text-9xl font-bold text-green-400 tabular-nums animate-scale-in">
            ${earnings.toFixed(2)}
          </div>
          <p className="text-2xl text-gray-400 mt-4">
            Earned this week
          </p>
          <div className="mt-12 grid grid-cols-3 gap-8 text-center animate-slide-up">
            <div>
              <div className="text-4xl font-bold text-blue-400">142</div>
              <div className="text-gray-500">Tasks Completed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-yellow-400">$2.5k</div>
              <div className="text-gray-500">This Month</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-green-400">4.9⭐</div>
              <div className="text-gray-500">Rating</div>
            </div>
          </div>
        </div>
      ),
      duration: 6000
    },
    // Slide 6: Market Size
    {
      id: 'market',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-5xl font-bold text-blue-400 mb-8 animate-fade-in">
            The Opportunity
          </h2>
          <div className="space-y-6 max-w-4xl animate-slide-up">
            <div className="bg-gray-900 border border-blue-400 rounded-lg p-6">
              <h3 className="text-2xl font-bold text-white mb-2">30 Million</h3>
              <p className="text-gray-400">Slack users worldwide</p>
            </div>
            <div className="bg-gray-900 border border-green-400 rounded-lg p-6">
              <h3 className="text-2xl font-bold text-white mb-2">$455 Billion</h3>
              <p className="text-gray-400">Global gig economy market size</p>
            </div>
            <div className="bg-gray-900 border border-yellow-400 rounded-lg p-6">
              <h3 className="text-2xl font-bold text-white mb-2">10-20% Platform Fee</h3>
              <p className="text-gray-400">Revenue on every transaction</p>
            </div>
          </div>
        </div>
      ),
      duration: 6000
    },
    // Slide 7: Why It Works
    {
      id: 'why',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-5xl font-bold text-purple-400 mb-8 animate-fade-in">
            Why TaskTap Wins
          </h2>
          <div className="grid grid-cols-2 gap-6 max-w-4xl animate-scale-in">
            <div className="bg-gradient-to-br from-purple-900/20 to-purple-600/20 border border-purple-400 rounded-lg p-6">
              <h3 className="text-xl font-bold text-purple-400 mb-2">Zero Friction</h3>
              <p className="text-gray-300">Already in Slack, one click to claim</p>
            </div>
            <div className="bg-gradient-to-br from-green-900/20 to-green-600/20 border border-green-400 rounded-lg p-6">
              <h3 className="text-xl font-bold text-green-400 mb-2">Trust Through Tech</h3>
              <p className="text-gray-300">Instant deletion = no double claims</p>
            </div>
            <div className="bg-gradient-to-br from-blue-900/20 to-blue-600/20 border border-blue-400 rounded-lg p-6">
              <h3 className="text-xl font-bold text-blue-400 mb-2">Instant Gratification</h3>
              <p className="text-gray-300">Complete task, get paid immediately</p>
            </div>
            <div className="bg-gradient-to-br from-yellow-900/20 to-yellow-600/20 border border-yellow-400 rounded-lg p-6">
              <h3 className="text-xl font-bold text-yellow-400 mb-2">Viral Growth</h3>
              <p className="text-gray-300">Workers invite workers naturally</p>
            </div>
          </div>
        </div>
      ),
      duration: 7000
    },
    // Slide 8: Traction
    {
      id: 'traction',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-5xl font-bold text-green-400 mb-8 animate-fade-in">
            Early Traction
          </h2>
          <div className="space-y-8 animate-slide-up">
            <div className="text-center">
              <div className="text-6xl font-bold text-white mb-2">Working MVP</div>
              <p className="text-xl text-gray-400">Live on CloudFlare Workers</p>
            </div>
            <div className="flex justify-center space-x-12">
              <div className="text-center">
                <div className="text-4xl font-bold text-green-400">$77</div>
                <p className="text-gray-500">Test earnings</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-400">3 sec</div>
                <p className="text-gray-500">Claim time</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-yellow-400">100%</div>
                <p className="text-gray-500">Success rate</p>
              </div>
            </div>
            <div className="text-center mt-8">
              <p className="text-2xl text-gray-300">
                "This could genuinely be a <span className="text-green-400 font-bold">$2M product</span>"
              </p>
              <p className="text-gray-500 mt-2">- Early adopter feedback</p>
            </div>
          </div>
        </div>
      ),
      duration: 6000
    },
    // Slide 9: Call to Action
    {
      id: 'cta',
      content: (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500 mb-8 animate-fade-in">
            Ready to TaskTap?
          </h2>
          <div className="space-y-6 text-center animate-scale-in">
            <p className="text-2xl text-gray-300 max-w-2xl">
              Turn your Slack workspace into a productivity powerhouse
            </p>
            <div className="flex flex-col items-center space-y-4">
              <button className="bg-gradient-to-r from-green-400 to-blue-500 text-black font-bold py-4 px-8 rounded-lg text-xl transform hover:scale-105 transition-all animate-pulse">
                Get Early Access
              </button>
              <p className="text-gray-500">Join 100+ companies already using TaskTap</p>
            </div>
            <div className="mt-12 flex justify-center space-x-8 text-gray-400">
              <a href="#" className="hover:text-green-400 transition-colors">Documentation</a>
              <a href="#" className="hover:text-green-400 transition-colors">API</a>
              <a href="#" className="hover:text-green-400 transition-colors">Pricing</a>
              <a href="#" className="hover:text-green-400 transition-colors">Contact</a>
            </div>
          </div>
        </div>
      ),
      duration: 10000
    }
  ];

  // Auto-advance slides
  useEffect(() => {
    if (!isAutoPlaying) return;

    const timer = setTimeout(() => {
      if (currentSlide < slides.length - 1) {
        setCurrentSlide(currentSlide + 1);
      } else {
        setIsAutoPlaying(false);
      }
    }, slides[currentSlide].duration);

    return () => clearTimeout(timer);
  }, [currentSlide, isAutoPlaying, slides]);

  // Animate earnings counter on slide 5
  useEffect(() => {
    if (currentSlide === 4) {
      setEarnings(0);
      const interval = setInterval(() => {
        setEarnings(prev => {
          if (prev >= 2487.50) {
            clearInterval(interval);
            return 2487.50;
          }
          return prev + 27.50;
        });
      }, 30);
      return () => clearInterval(interval);
    }
  }, [currentSlide]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'ArrowRight' && currentSlide < slides.length - 1) {
        setCurrentSlide(currentSlide + 1);
        setIsAutoPlaying(false);
      } else if (e.key === 'ArrowLeft' && currentSlide > 0) {
        setCurrentSlide(currentSlide - 1);
        setIsAutoPlaying(false);
      } else if (e.key === ' ') {
        setIsAutoPlaying(!isAutoPlaying);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [currentSlide, slides.length, isAutoPlaying]);

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden relative">
      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slide-up {
          from { transform: translateY(30px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes scale-in {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
        .animate-slide-up {
          animation: slide-up 1s ease-out 0.3s both;
        }
        .animate-scale-in {
          animation: scale-in 0.8s ease-out 0.2s both;
        }
      `}</style>

      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-900/10 via-black to-blue-900/10" />

      {/* Slide content */}
      <div className="relative h-screen px-8 py-12">
        {slides[currentSlide].content}
      </div>

      {/* Navigation controls */}
      <div className="absolute bottom-8 left-0 right-0">
        <div className="max-w-4xl mx-auto px-8">
          {/* Progress dots */}
          <div className="flex justify-center space-x-2 mb-4">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  setCurrentSlide(index);
                  setIsAutoPlaying(false);
                }}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentSlide
                    ? 'w-8 bg-green-400'
                    : 'bg-gray-600 hover:bg-gray-500'
                }`}
              />
            ))}
          </div>

          {/* Navigation buttons */}
          <div className="flex justify-between items-center">
            <button
              onClick={() => {
                if (currentSlide > 0) {
                  setCurrentSlide(currentSlide - 1);
                  setIsAutoPlaying(false);
                }
              }}
              className={`px-4 py-2 rounded transition-all ${
                currentSlide > 0
                  ? 'bg-gray-800 hover:bg-gray-700 text-white'
                  : 'bg-gray-900 text-gray-600 cursor-not-allowed'
              }`}
              disabled={currentSlide === 0}
            >
              ← Previous
            </button>

            <button
              onClick={() => setIsAutoPlaying(!isAutoPlaying)}
              className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded text-white transition-all"
            >
              {isAutoPlaying ? '⏸ Pause' : '▶ Play'}
            </button>

            <button
              onClick={() => {
                if (currentSlide < slides.length - 1) {
                  setCurrentSlide(currentSlide + 1);
                  setIsAutoPlaying(false);
                }
              }}
              className={`px-4 py-2 rounded transition-all ${
                currentSlide < slides.length - 1
                  ? 'bg-gray-800 hover:bg-gray-700 text-white'
                  : 'bg-gray-900 text-gray-600 cursor-not-allowed'
              }`}
              disabled={currentSlide === slides.length - 1}
            >
              Next →
            </button>
          </div>

          {/* Keyboard hints */}
          <div className="text-center text-gray-600 text-sm mt-4">
            Use ← → arrows to navigate • Space to play/pause
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskTapPitch;